import React, { useState, useEffect } from "react";
import "./Navbar.css";
import axiosConfig from "../../Service/axiosConfig";
import { useSelector } from "react-redux";
import {
  selectCartTotal,
  selectCartProducts,
} from "../../redux/Slices/cartSlice";
import {
  MdShoppingCart,
  MdOutlineHome,
  MdSearch,
  MdOutlineAddCircleOutline,
  MdWorkOutline,
  MdOtherHouses,
  MdArrowDropDown,
} from "react-icons/md";
import Modal from "react-bootstrap/Modal";
import { ViewCart } from "./ViewCart";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Login } from "../Login";
import { AddressModal, LocationModalNavBar, PopupModal } from "../PopupModal";
import { IoMdArrowDropdown } from "react-icons/io";
import { AccessDeny, LocationModal } from "../PopupModal";
import { RiAccountCircleLine, RiBook3Line } from "react-icons/ri";
import { HiOutlineArrowLeft } from "react-icons/hi";
import { BiSearch } from "react-icons/bi";
import { AiOutlineHeart } from "react-icons/ai";
import { IoIosHeartEmpty } from "react-icons/io";
import { LoginModal } from "../LoginModal/LoginModal";
import { FormParser } from "../FormParser/FormParser";
import Masters from "../masters.json";
import ViewCartModal from "./ViewCartModal";
import AddAddress from "../PopupModal/AddAddress";
import { HomeMeta } from "..";
import { CiDiscount1, CiShop, CiMobile3 } from "react-icons/ci";
import { PiBookLight } from "react-icons/pi";
import { getDistanceInKm } from "../../Utils/geolocation";

const Navbar = ({ search, LoginAccount }) => {
  const location = useLocation();
  const DELIVERY_RADIUS_KM = 4;
  const Navigate = useNavigate();
  const [name, setName] = useState("");
  const [smShow, setSmShow] = useState(false);
  const [amount, setAmount] = useState("");
  const { cart } = useSelector((state) => state);
  const total = useSelector(selectCartTotal);
  const [locationUpdated, setLocationUpdated] = useState(0);
  const [show, setShow] = useState(false);
  const [LoggedIn, setLoggedIn] = useState(false);
  const [loginShow, setloginShow] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [query, setQuery] = useState(search);
  const [count, setCount] = useState(1);
  const [showWishlist, setShowWishlist] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [popupType, setPopupType] = useState("");
  const [addressModal, setAddressModal] = useState(false);
  const [Address, setAddress] = useState([]);
  const [news, SetNews] = useState(null);
  const [defaultAddress, setDefaultAddress] = useState();
  const [orderAddress, setOrderAddress] = useState();
  const [ActiveUrl, setActiveUrl] = useState("");
  const [LocationAddress, setLocationAddress] = useState("");
  const [LocationNavBarType, setLocatioNavBarType] = useState("");
  const [NoAccess, setNoAccess] = useState("");
  const [LocationpopupType, setLocationpopupType] = useState("");
  const [NoStock, setNoStock] = useState([]);
  const [Error, SetError] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1020);
  const products = useSelector(selectCartProducts);
  const rentTotal = (cart?.rentCart || []).reduce((acc, r) => acc + (Number(r.offerPrice || 0) * Number(r.qty || 1)), 0);
  const displayTotal = total + rentTotal;
  const totalCartCount = (cart?.products || []).length + (cart?.rentCart || []).length;
  const [errorMsg, setErrorMsg] = useState(null);
  const [Totalamount, setTotalAmount] = useState({
    Total_amount: 0,
  });
  const wishlists = useSelector((state) => state.cart.wishlists);
  const [errorMessage, setErrorMessage] = useState(null)
  const [siteData, setSiteData] = useState({
    logo: { image: localStorage.getItem("siteLogo") || "" },
    companyName: ""
  });
  const [message, setMessage] = useState(null);
  const MastersModal =
    JSON.parse(localStorage.getItem("site_data"))?.ecommerce_type ===
      "Hyperlocal"
      ? Masters.AddAddressHyperlocal
      : Masters.AddAddress;
  const [ecommerceType, setEcommerceType] = useState("");
  const [storeNull, setStoreNull] = useState(false);
  const [Online, SetOnline] = useState(false);
  const [OpensAt, SetOpensAt] = useState(false);
  const [travelTime, SetTravelTime] = useState();
  const [categories, setCategories] = useState([]);
  const handleResize = () => {
    setIsMobile(window.innerWidth < 1020);
  };
  let ProductData = [];
  const initialOrderState = {
    address: "",
    products: [],
    stores: localStorage.getItem("storeId"),
    user_id: localStorage.getItem("userId"),
    packing_charges: 0,
    delivery_charges: 0,
  };
  const scheduleDate = localStorage
    .getItem("selected_date")
    ?.split("-")
    .reverse()
    .join("-");
  if (scheduleDate) {
    initialOrderState.schedule_date = scheduleDate;
  }
  const [Order, setOrders] = useState(initialOrderState);
  console.log(Order, cart);
  function handleInputChange(event) {
    setQuery(event.target.value);
  }
  const ActiveData = (activeUrl) => {
    localStorage.setItem("activeurl", activeUrl);
  };
  const GetlocaData = () => {
    const Accounturl = localStorage.getItem("activeurl");
    setActiveUrl(Accounturl);
  };
  function handleSubmit(event) {
    event.preventDefault();
    Navigate(`/product-search?query=${query}`);
  }
  console.log("Navbar count:", count);
  const handleLoginShow = () => {
    setloginShow(true);
  };
  const GetData = async () => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      setAddress([]);
      return;
    }
    try {
      const response = await axiosConfig.get(
        `/accounts/address/?user=${userId}&is_suspended=false`
      );
      const addressList = response.data.results;

      setAddress(addressList);
      if (addressList.length === 0) {
        setAddressModal(true);
      }
      const defaultAddress = addressList.find(
        (item) => item.is_default === true
      );
      localStorage.setItem("full_name", addressList[0]?.user?.full_name)
      if (defaultAddress) {
        // ✅ SAVE IN LOCAL STORAGE
        localStorage.setItem("address_id", defaultAddress.id);
        localStorage.setItem("address", defaultAddress.address);
        localStorage.setItem("latitude", defaultAddress.latitude);
        localStorage.setItem("longitude", defaultAddress.longitude);
        localStorage.setItem("name", defaultAddress.name);
      }
    } catch (error) {
      console.log(error);
    }
  };
  async function getCategories() {
    try {
      const res = await axiosConfig.get(
        "/catlog/with-buy-or-both/?is_suspended=false"
      );

      setCategories(res.data || []);
    } catch (error) {
      console.log(error);
    }
  }
  useEffect(() => {
    getCategories();
  }, []);
  const GetNews = async () => {
    // API call removed as requested
  };

  const GetSiteData = async () => {
    try {
      let site_response;
      try {
        site_response = await axiosConfig.get("/sitedata/site-config/");
      } catch (err) {
        console.warn("site-config failed, falling back to site API", err);
        site_response = await axiosConfig.get("/sitedata/site/");
      }

      const isNewConfig = !!site_response?.data?.site;
      let siteObject = site_response?.data?.site || site_response?.data?.results?.[0];

      if (siteObject) {
        if (isNewConfig) {
          const themeObject = site_response.data.theme || {};
          const tenantObject = site_response.data.tenant || {};
          const logoUrl = themeObject.logo_url || "";

          if (logoUrl) {
            localStorage.setItem("siteLogo", logoUrl);
          }

          siteObject = {
            ...siteObject,
            ...themeObject,
            logo: { image: logoUrl || localStorage.getItem("siteLogo") || "" },
            companyName: tenantObject.company_name || siteObject.title || "",
            favicon: { image: themeObject.favicon_url || "" },
          };
        }

        setSiteData(siteObject);
        // document.title = siteObject.title;
        const favicon =
          document.querySelector("link[rel='icon']") ||
          document.createElement("link");
        favicon.rel = "icon";
        favicon.href = siteObject.favicon?.image || "";
        // document.head.appendChild(favicon);
        setEcommerceType(siteObject.ecommerce_type);
        localStorage.setItem(
          "site_data",
          JSON.stringify(siteObject)
        );
        const root = document.documentElement;
        const primary_color = siteObject.default_primary
          ? "#735ceb"
          : siteObject.primary_color;
        const secondary_color = siteObject.default_secondary
          ? "#e6ffe8"
          : siteObject.secondary_color + "80";
        root.style.setProperty("--primary_color", primary_color);
        root.style.setProperty("--secondary_color", secondary_color);
        if (siteObject.ecommerce_type === "Hyperlocal") {
          HandleLocationPopup();
        } else {
          const default_response = await axiosConfig.get(
            `/stores/stores/?is_default=true`
          );
          if (
            default_response.data.results.length > 0 &&
            localStorage.getItem("storeId") === null
          ) {
            setDefaultAddress(default_response.data.results[0].address);
            localStorage.setItem("storeId", default_response.data.results[0].id);
            if (!JSON.parse(localStorage.getItem("address"))) {
              localStorage.setItem(
                "address",
                default_response.data.results[0].address
              );
            }
            localStorage.setItem(
              "latitude",
              default_response.data.results[0].latitude
            );
            localStorage.setItem(
              "longitude",
              default_response.data.results[0].longitude
            );
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
  };
  const GetTheAddress = () => {
    setCount(2);
    GetData();
  };
  const GetAddress = async (id) => {
    try {
      if (
        JSON.parse(localStorage.getItem("site_data")).ecommerce_type ===
        "Conventional"
      ) {
        return null;
      }
      const response = await axiosConfig.get(`/accounts/address/${id}/`);
      // const store_response = await axiosConfig.get(
      //   `/stores/get_store/?latitude=${response.data.latitude}&longitude=${response.data.longitude}`
      // );
      const store_response = { data: { Message: { store_id: 1, is_online: "online" } } };
      if (
        store_response.data.Message.store_id !== null &&
        ecommerceType === "Hyperlocal"
      ) {
        // const isOnline = store_response.data.Message.is_online === "online";
        // localStorage.setItem("online", JSON.stringify(isOnline));

        // localStorage.setItem(
        //   "online",
        //   store_response.data.Message.is_online === "offline" ? true : false
        // );
        localStorage.setItem("storeId", store_response.data.Message.store_id);
        localStorage.setItem("opens_at", store_response.data.Message.opens_at);
        localStorage.setItem(
          "closes_at",
          store_response.data.Message.closes_at
        );
        localStorage.setItem(
          "slot_duration",
          store_response.data.Message.slot_duration
        );
        // window.location.reload();
        setOrderAddress(response.data);
        localStorage.setItem("name", response.data.name);
        localStorage.setItem("address_id", response.data.id);
        localStorage.setItem("address", response.data.address);
        localStorage.setItem("latitude", response.data.latitude);
        localStorage.setItem("longitude", response.data.longitude);
        if (store_response.data.Message.is_online === "offline") {
          localStorage.setItem("express_delivery", false);
          localStorage.removeItem("express_delivery_time");
          SetTravelTime();
        } else {
          localStorage.setItem(
            "express_delivery",
            store_response.data.Message.express_delivery
          );
          if (
            store_response.data.Message.express_delivery &&
            store_response.data.Message.express_delivery_time
          ) {
            localStorage.setItem(
              "express_delivery_time",
              store_response.data.Message.express_delivery_time
            );
            SetTravelTime(store_response.data.Message.express_delivery_time);
          } else {
            localStorage.removeItem("express_delivery_time");
            SetTravelTime();
          }
        }
        (cart?.products || []).forEach((res) => {
          console.log(res);
          ProductData.push({
            id: res.id,
            min_qty: res.quantity,
          });
        });
        setOrders({
          ...Order,
          stores: localStorage.getItem("storeId"),
          user_id: parseFloat(localStorage.getItem("userId")),
          address: id,
          products: ProductData,
        });
        setStoreNull(false);
      } else if (ecommerceType === "Conventional") {
        setOrderAddress(response.data);
        localStorage.setItem("name", response.data.name);
        localStorage.setItem("address_id", response.data.id);
        localStorage.setItem("address", response.data.address);
        localStorage.setItem("latitude", response.data.latitude);
        localStorage.setItem("longitude", response.data.longitude);
        (cart?.products || []).forEach((res) => {
          console.log(res);
          ProductData.push({
            id: res.id,
            min_qty: res.quantity,
          });
        });
        setOrders({
          ...Order,
          stores: localStorage.getItem("storeId"),
          user_id: parseFloat(localStorage.getItem("userId")),
          address: id,
          products: ProductData,
        });
      } else {
        setStoreNull(true);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const ChangeAddress = () => {
    setCount(2);
    // setOrderAddress();
  };
  const MovetoCart = () => {
    setCount(1);
    setOrderAddress();
    setStoreNull(false);
  };
  const HandleAddress = () => {
    setAddressModal(true);
  };

  const closeAddressModal = () => {
    setAddressModal(false);
    setErrorMsg(null);
    SetError("");
  };

  const formSubmit = async (Data) => {
    SetError("");
    setErrorMsg(null);
    setPopupType("");
    setMessage("");
    try {
      axiosConfig.defaults.headers["Content-Type"] = "multipart/form-data";
      // const store_response = await axiosConfig.get(
      //   `/stores/get_store/?latitude=${Data.latitude}&longitude=${Data.longitude}`
      // );
      const store_response = { data: { Message: { store_id: 1 } } };
      const message = store_response?.data?.Message || {};

      let resolvedStoreId = message.store_id;
      if (!resolvedStoreId && ecommerceType !== "Conventional") {
        // Fallback for cases where get_store returns null for edge coordinates:
        // pick nearest non-suspended store within service radius.
        const storesRes = await axiosConfig.get(
          `/stores/stores/?page=1&page_size=50&is_suspended=false`
        );
        const stores = storesRes?.data?.results || [];
        const nearest = stores
          .filter((s) => s.latitude && s.longitude && !s.is_suspended)
          .map((s) => ({
            ...s,
            distance: getDistanceInKm(
              parseFloat(Data.latitude),
              parseFloat(Data.longitude),
              parseFloat(s.latitude),
              parseFloat(s.longitude)
            ),
          }))
          .filter((s) => s.distance <= DELIVERY_RADIUS_KM)
          .sort((a, b) => {
            if (a.is_online !== b.is_online) {
              return a.is_online === "online" ? -1 : 1;
            }
            return a.distance - b.distance;
          })[0];

        if (nearest) {
          resolvedStoreId = nearest.id;
        }
      }

      if (resolvedStoreId !== null && resolvedStoreId !== undefined) {
        const res = await axiosConfig.post(`/accounts/address/`, {
          ...Data,
          user: localStorage.getItem("userId"),
        });
        console.log(res, "address added");
        setPopupType("success");
        setAddressModal(false);
        setMessage("Address added successfully");
        GetData();
        setCount(1);
        if (ecommerceType !== "Conventional") {
          localStorage.setItem("storeId", resolvedStoreId);
        }
      } else if (
        resolvedStoreId === null &&
        ecommerceType === "Conventional"
      ) {
        const res = await axiosConfig.post(`/accounts/address/`, {
          ...Data,
          user: localStorage.getItem("userId"),
        });
        console.log(res, "address added");
        setPopupType("success");
        setAddressModal(false);
        setMessage("Address added successfully");
        GetData();
        setCount(1);
      } else {
        setPopupType("error");
        SetError("No service Available at this location");
        setMessage("No service Available at this location");
      }
    } catch (error) {
      console.error(error);
      setPopupType("error");
      SetError("error adding address");
    }
  };

  const PayMentNavigate = async () => {
    const addressId = Number(Order?.address || localStorage.getItem("address_id") || orderAddress?.id || 0);
    const listingType = localStorage.getItem("listingType") || "rent";
    const scheduleDate = localStorage.getItem("selected_date")?.split("-").reverse().join("-") || new Date().toISOString().split('T')[0];

    if (!addressId) {
      setErrorMessage(Date.now() + `-Missing required order data: address`);
      return;
    }

    const hasSale = (cart?.products || []).length > 0;
    const hasRent = (cart?.rentCart || []).length > 0;

    const orderDetails = [
      ...(cart?.products || []).map((item) => {
        const activePackage = item.selectedPackage || item;
        return {
          variant: item.id,
          quantity: item.quantity || 1,
          item_type: "sale",
          rental_start_date: scheduleDate,
          package_name: activePackage?.package_name || "Weekly",
          duration_value: activePackage?.duration_value || 1,
          unique_id: item.uuid || (Date.now().toString(36) + Math.random().toString(36).substr(2))
        };
      }),
      ...(cart?.rentCart || []).map((item) => {
        return {
          variant: item.id,
          quantity: item.qty || 1,
          item_type: "rent",
          rental_start_date: item.fromDate || scheduleDate,
          package_name: item.rentalPlan,
          duration_value: item.duration || 1,
          unique_id: item.cartItemId || (Date.now().toString(36) + Math.random().toString(36).substr(2))
        };
      })
    ];

    const payload = {
      sale_addresses: hasSale ? addressId : "",
      rental_addresses: hasRent ? addressId : "",
      delivery_mode: "company-transport",
      order_details: orderDetails
    };

    let request_type = "post";
    let url = "/accounts/orders/";
    if (localStorage.getItem("orderId")) {
      payload["order_id"] = localStorage.getItem("orderId");
      request_type = "put";
      url = `/accounts/orders/${localStorage.getItem("orderId")}/`;
    }
    try {
      axiosConfig.defaults.headers["Content-Type"] = "application/json";
      const res = await axiosConfig[request_type](url, payload);
      localStorage.setItem("orderId", res.data.id);
      Navigate("/checkout");
    } catch (error) {
      console.error("Order create/update failed", error?.response?.data || error);
      if (error.response && error.response.data.error) {
        const errMsg = error.response?.data?.error || error.response?.data?.message;
        setErrorMessage(Date.now() + "-" + errMsg);
      } else if (error.response && error.response.data.message) {
        const errMsg = error.response?.data?.error || error.response?.data?.message;
        setErrorMessage(Date.now() + "-" + errMsg);
      }
      if (
        error.response &&
        error.response.data[
        "The following products are not available in the store:"
        ]
      ) {
        error.response.data[
          "The following products are not available in the store:"
        ].forEach(async (res) => {
          try {
            const productRes = await axiosConfig.get(
              `/catlog/products/${res.id}/?is_suspended=false`
            );
            setNoStock((prestate) => [...prestate, productRes.data]);
            setSmShow(true);
          } catch (error) {
            console.error(error);
          }
        });
      }
    }
  };
  const AddressLocal = async (id) => {
    try {
      const response = await axiosConfig.get(
        `/accounts/address/${localStorage.getItem(
          "address_id"
        )}/?is_suspended=false`
      );
      setOrderAddress(response.data);
      (cart?.products || []).forEach((res) => {
        console.log(res);
        ProductData.push({
          id: res.id,
          min_qty: res.quantity,
        });
      });
      setOrders({
        ...Order,
        stores: localStorage.getItem("storeId"),
        user_id: parseFloat(localStorage.getItem("userId")),
        address: localStorage.getItem("address_id"),
        products: ProductData,
      });
    } catch (error) {
      console.log(error);
    }
  };
  const HndleSmallShow = () => {
    setSmShow(false);
    setNoStock("");
    setErrorMsg(null);
  };
  const checkLogin = () => {
    setLoggedIn(true);
  };
  const HandleLocationPopup = () => {
    if (localStorage.getItem("storeId")) {
      setLocationpopupType("");
    } else {
      setLocationpopupType("success");
    }
  };
  const HandlepopupAddress = () => {
    console.log(LocationpopupType);
    if (LocationpopupType === "success") {
      setLocationpopupType("");
      setTimeout(() => {
        setLocationpopupType("success");
      }, 100);
    } else {
      setLocationpopupType("success");
    }
  };
  const handlePlaceChanged = async (latitude, longitude) => {
    try {
      // const response = await axiosConfig.get(
      //   `/stores/get_store/?latitude=${latitude}&longitude=${longitude}`
      // );
      const response = { data: { Message: { store_id: 1, is_online: "online", opens_at: "", schedule_delivery: false, express_delivery: false } } };

      if (response.data.Message.store_id !== null) {
        console.log(response.data.Message);
        // Critical: persist the nearest serviceable store resolved by backend
        // for the selected home-page address coordinates.
        localStorage.setItem("storeId", response.data.Message.store_id);
        // localStorage.setItem(
        //   "online",
        //   response.data.Message.is_online === "offline" ? true : false
        // );
        const isOnline = response.data.Message.is_online === "online";
        localStorage.setItem("online", JSON.stringify(isOnline));

        localStorage.setItem("opens_at", response.data.Message.opens_at);
        localStorage.setItem(
          "schedule_delivery",
          response.data.Message.schedule_delivery
        );
        if (response.data.Message.is_online === "offline") {
          localStorage.setItem("express_delivery", false);
          localStorage.removeItem("express_delivery_time");
        } else {
          // localStorage.setItem(
          //   "express_delivery",
          //   response.data.Message.express_delivery
          // );
          localStorage.setItem("express_delivery", response.data.Message.express_delivery);
          if (
            response.data.Message.express_delivery &&
            response.data.Message.express_delivery_time
          ) {
            localStorage.setItem(
              "express_delivery_time",
              response.data.Message.express_delivery_time
            );
            SetTravelTime(response.data.Message.express_delivery_time);
          } else {
            localStorage.removeItem("express_delivery_time");
            SetTravelTime();
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (localStorage.getItem("address_id")) {
      AddressLocal();
    }
    if (localStorage.getItem("token") || LoginAccount) {
      checkLogin();
    }
    const latitude = localStorage.getItem("latitude");
    const longitude = localStorage.getItem("longitude");
    if (latitude && longitude) {
      handlePlaceChanged(latitude, longitude);
    }
    GetData();
    GetNews();
    GetSiteData();
    GetlocaData();
    // HandleLocationPopup();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [LoggedIn, locationUpdated]);


  // useEffect(() => {
  //   const initializeData = async () => {
  //     setIsLoading(true);

  //     // Load all data in parallel
  //     await Promise.all([
  //       GetData(),
  //       GetNews(),
  //       GetSiteData(),
  //       GetlocaData()
  //     ]);

  //     // Then check location
  //     const latitude = localStorage.getItem("latitude");
  //     const longitude = localStorage.getItem("longitude");
  //     if (latitude && longitude) {
  //       await handlePlaceChanged(latitude, longitude);
  //     }

  //     setIsLoading(false);
  //   };

  //   if (localStorage.getItem("token") || LoginAccount) {
  //     checkLogin();
  //   }

  //   if (localStorage.getItem("address_id")) {
  //     AddressLocal();
  //   }

  //   initializeData();

  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, [LoggedIn]);

  // if (isLoading) return null;
  const MobileLogin = () => {
    Navigate("/account");
  };
  const handlePrivacyClick = (event) => {
    event.preventDefault();
    Navigate("/privacy");
  };
  const openWishlistPopup = () => {
    if (showWishlist) {
      Navigate("/wishlist");
    } else {
      if (LoggedIn) {
        setShowWishlist(true);
        Navigate("/wishlist");
      } else {
        setloginShow(true);
      }
    }
  };
  function formatOpeningTime(openingTime) {
    // Assuming openingTime is in 24-hour format HH:mm
    const [hours, minutes] = openingTime.split(":");
    const formattedHours = parseInt(hours) % 12 || 12;
    const amOrPm = parseInt(hours) >= 12 ? "PM" : "AM";
    return `${formattedHours}:${minutes} ${amOrPm}`;
  }

  const isCheckout = location.pathname === '/checkout';

  if (isCheckout) {
    return (
      <div className="navbar-container template-temp2" style={{ height: '70px' }}>
        <nav className="navbar fixed-top navbar-expand-lg" style={{ background: '#fff', boxShadow: '0 2px 4px rgba(0,0,0,0.08)', padding: '10px 0', minHeight: '70px' }}>
          <div className="container-fluid">
            <NavLink to="/" className="navbar-brand" style={{ margin: 0 }}>
              {siteData?.logo?.image ? (
                <img src={siteData.logo.image} alt={siteData?.companyName || "logo"} style={{ maxHeight: '50px' }} />
              ) : (
                <h2 className="site-title" style={{ margin: 0, fontWeight: 'bold' }}>{siteData?.companyName || "Logo"}</h2>
              )}
            </NavLink>
          </div>
        </nav>
      </div>
    );
  }

  return (
    <>
      {isMobile ? (
        <div className="navBar-mobile-main">
          <header className="nav-mobile-header">
            <div className="nav-mobile-location">
              <div
                onClick={
                  ecommerceType === "Hyperlocal" ? HandlepopupAddress : null
                }
              >
                <div className="nav-mobile-time">
                  {ecommerceType === "Hyperlocal"
                    ? travelTime
                      ? `Delivery in ${travelTime} minutes`
                      : "Delivering to"
                    : "Delivering to"}
                </div>

                {ecommerceType === "Hyperlocal" ? (
                  <div className="nav-mobile-store">
                    {localStorage.getItem("address")}
                    <MdArrowDropDown size={24} />
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="d-flex">
                <IoIosHeartEmpty
                  className="nav-heart-icon-mobile"
                  onClick={openWishlistPopup}
                />
                <div onClick={LoggedIn ? MobileLogin : handleLoginShow}>
                  <RiAccountCircleLine className="account-mobile" />
                </div>
              </div>

            </div>

            <div className="search-mobile-main">
              <NavLink to="/s" className="position-relative">
                <div className="search-div">
                  <MdSearch className="search-icon" />

                  <input
                    type="text"
                    className="form-control"
                    value={query}
                    onChange={handleInputChange}
                  />
                </div>
              </NavLink>
            </div>
          </header>
        </div>
      ) : (
        <>
          <div className="grocery-essential">
            <div className="container d-flex justify-content-between">
              <div className="grocery-essential-para">
                {news?.show_news && (
                  <marquee direction="right" scrollamount="5">
                    {news?.scrolling_point}
                  </marquee>
                )}
              </div>
              <ul className="grocery-essential-ul">
                <li className="grocery-essential-li">
                  <CiDiscount1 className="icon" />
                  <NavLink to="/offers" className="grocery-essential-data">
                    OFFERS
                  </NavLink>
                </li>
                <li className="grocery-essential-li">
                  <PiBookLight className="icon" />
                  <NavLink to="/blogs" className="grocery-essential-data">
                    BLOGS
                  </NavLink>
                </li>
                {/* <li className="grocery-essential-li">
                  <CiMobile3 className="icon" />
                  <a
                    href="https://play.google.com/store/search?q=opoto&c=apps&hl=en"
                    target="_blank"
                    className="grocery-essential-data"
                  >
                    GET APP
                  </a>
                </li> */}
              </ul>
            </div>
          </div>

          <div className="navbar-container">
            <nav className="navbar fixed-top navbar-expand-lg">
              <div className="container-fluid">
                {console.log("site data", siteData)}
                <NavLink to="/" className="navbar-brand">
                  {siteData?.logo?.image ? (
                    <img src={siteData.logo.image} alt={siteData?.companyName || "logo"} />
                  ) : (
                    <h2 className="site-title">{siteData?.companyName || "Logo"}</h2>
                  )}
                </NavLink>
                <button
                  className="navbar-toggler"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon"></span>
                </button>
                <div
                  className="collapse navbar-collapse"
                  id="navbarSupportedContent"
                >
                  <div
                    className="location-nav-main"
                    onClick={
                      ecommerceType === "Hyperlocal" ? HandlepopupAddress : null
                    }
                  >
                    <div className="location-title">
                      {ecommerceType === "Hyperlocal"
                        ? travelTime
                          ? `Delivery in ${travelTime} minutes`
                          : "Delivering to"
                        : "Delivering to"}
                    </div>

                    {ecommerceType === "Hyperlocal" ? (
                      <div className="d-flex align-items-center">
                        <div className="location-name">
                          {LocationAddress
                            ? LocationAddress
                            : localStorage.getItem("address")
                              ? localStorage.getItem("address")
                              : ""}
                        </div>
                        <MdArrowDropDown size={24} />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="v-divider">
                    <div
                      className={`listing-type-btn ${location.pathname.replace(/\/$/, "") === "/sale" ? "active" : ""}`}
                      onClick={() => {
                        localStorage.setItem("listingType", "buy");
                        Navigate(`/sale`, {
                          state: { listingType: "buy" },
                        });
                      }}
                    >
                      Sale
                    </div>

                    <div
                      className={`listing-type-btn ${location.pathname.replace(/\/$/, "") === "/rent" ? "active" : ""}`}
                      onClick={() => {
                        localStorage.setItem("listingType", "rent");
                        Navigate(`/rent`, {
                          state: { listingType: "rent" },
                        });
                      }}
                    >
                      Rent
                    </div>
                  </div>
                  <form className="ml-auto search-form" onSubmit={handleSubmit}>
                    <NavLink
                      to="/s"
                      className="position-relative text-decoration-none"
                    >
                      <div className="search-div">
                        <MdSearch className="search-icon" />
                        <input
                          type="text"
                          className="form-control placeholderEle"
                          placeholder="Enter the product Name"
                          value={query}
                          onChange={handleInputChange}
                        />
                      </div>
                    </NavLink>
                  </form>
                  <div className="nav-content">
                    <ul className="navbar-nav">
                      {LoggedIn ? (
                        <li className="nav-item dropdown">
                          <a
                            className="nav-link dropdown-toggle"
                            href="#"
                            id="navbarDropdown"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            Account
                          </a>
                          <ul
                            className="dropdown-menu"
                            aria-labelledby="navbarDropdown"
                          >
                            <li>
                              <a className="dropdown-item">
                                <p>My Account</p>
                                <p>{localStorage.getItem("number")}</p>
                              </a>
                            </li>
                            <li>
                              <hr className="dropdown-divider" />
                            </li>
                            <li>
                              <NavLink
                                to="/account/orders"
                                className="dropdown-item"
                                onClick={() => ActiveData("/account/orders")}
                              >
                                My Orders
                              </NavLink>
                            </li>
                            <li>
                              <NavLink
                                to="/account/addresses"
                                className="dropdown-item"
                                onClick={() => ActiveData("/account/addresses")}
                              >
                                Saved Address
                              </NavLink>
                            </li>
                            <li>
                              <NavLink
                                to="/wishlist"
                                className="dropdown-item"
                                onClick={() => ActiveData("/wishlist")}
                              >
                                Wishlist
                              </NavLink>
                            </li>

                            {/* <li><NavLink to="/account/wallet" className="dropdown-item" onClick={() => ActiveData("/account/wallet")}>Wallet</NavLink></li> */}
                            <li>
                              <NavLink
                                to="/logout"
                                className="dropdown-item"
                                onClick={() => ActiveData("/logout")}
                              >
                                Log Out
                              </NavLink>
                            </li>
                          </ul>
                        </li>
                      ) : (
                        <button
                          className="btn btn-default login-btn"
                          onClick={handleLoginShow}
                        >
                          Login
                        </button>
                      )}
                    </ul>
                    <ul className="navbar-nav">
                      <li className="nav-item heart-badge">
                        <IoIosHeartEmpty
                          className="nav-heart-icon"
                          onClick={openWishlistPopup}
                        />

                        {wishlists.length > 0 && (
                          <span className="wishlist-count">
                            {wishlists.length}
                          </span>
                        )}
                      </li>
                    </ul>
                    <ul className="navbar-nav  mb-2 mb-lg-0">
                      <li className="nav-item">
                        <div
                          className="btn btn-success cart-container show-desktop"
                          onClick={handleShow}
                        >
                          <div className="cart-icon-holder">
                            <MdShoppingCart />
                          </div>
                          <div className="cart-qty">
                            {totalCartCount > 0 ? (
                              <p>{totalCartCount} items</p>
                            ) : (
                              <p>My Cart</p>
                            )}
                            <span className="p-price">${displayTotal?.toFixed(2)}</span>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </nav>
            <div className="navbar-bottom"></div>
          </div>
        </>
      )}
      <>
        {totalCartCount > 0 && (
          <div
            className="btn btn-success cart-container show-tablet"
            onClick={handleShow}
          >
            <div className="cart-icon-holder">
              <MdShoppingCart />
            </div>
            <div className="cart-qty">
              {totalCartCount > 0 ? (
                <p>{totalCartCount} items</p>
              ) : (
                <p>My Cart</p>
              )}
            </div>
            {console.log(Order, "inside navbar")}
            <span className="p-price">
              $
              {parseFloat(
                Totalamount.Total_amount -
                Order.packing_charges -
                Order.delivery_charges
              ).toFixed(2)}
            </span>
          </div>
        )}
      </>
      <ViewCartModal
        count={count}
        setCount={setCount}
        show={show}
        setShow={setShow}
        handleClose={handleClose}
        orderAddress={orderAddress}
        setOrderAddress={setOrderAddress}
        setOrders={setOrders}
        setErrorMessage={setErrorMessage}
        Order={Order}
        ProductData={ProductData}
        setTotalAmount={setTotalAmount}
        products={products}
        ChangeAddress={ChangeAddress}
        GetTheAddress={GetTheAddress}
        PayMentNavigate={PayMentNavigate}
        handleLoginShow={handleLoginShow}
        cart={cart}
        errorMessage={errorMessage}
        Totalamount={Totalamount}
        isMobile={isMobile}
        MovetoCart={MovetoCart}
        HandleAddress={HandleAddress}
        storeNull={storeNull}
        Address={Address}
        GetAddress={GetAddress}
        travelTime={travelTime}
      />
      <Modal className="template-temp2"
        size="sm"
        show={smShow}
        onHide={HndleSmallShow}
        aria-labelledby="example-modal-sizes-title-sm"
        centered
      >
        <Modal.Body>
          {Error ? (
            <>
              {" "}
              <div style={{ color: "red" }}>{Error}</div>
            </>
          ) : NoStock.length >= 1 ? (
            NoStock.map((res, i) => {
              console.log(res);
              return (
                <div key={i} className="p-avalibile">
                  {res.name}
                  <br />
                </div>
              );
            })
          ) : (
            <div className="p-avalibile">{NoStock.name}</div>
          )}
          {!errorMsg && (
            <div className="not-avalible text-center">
              Not Available in Selected Store
            </div>
          )}
          {errorMsg && <div className="min-value-error">{errorMsg}</div>}
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={HndleSmallShow}>
            Ok
          </button>
        </Modal.Footer>
      </Modal>
      {loginShow && (
        <LoginModal
          setLoginType={setloginShow}
          LoginType={loginShow}
          setLoggedIn={setLoggedIn}
          LoggedIn={LoggedIn}
        />
      )}
      {/* {
                popupType === "success" &&
                <AddressModal popupType={popupType} newAddressAdded={newAddressAdded} setPopupType={setPopupType} Location={localStorage.getItem("storeId") ? false : true} />
            } */}
      {/* <AddAddress
        addressModal={addressModal}
        closeAddressModal={closeAddressModal}
        MastersModal={MastersModal}
        GetData={GetData}
        formSubmit={formSubmit}
        setPopupType={setPopupType}
        Error={Error}
      /> */}
      {/* {LocationpopupType === "success" && (
        <LocationModal
          LocationpopupType={LocationpopupType}
          setLocationpopupType={setLocationpopupType}
          setLocationAddress={setLocationAddress}
          SetOnline={SetOnline}
          triggerLocationUpdate={() => setLocationUpdated(prev => prev + 1)}
        />
      )} */}
      {NoAccess === "success" && (
        <AccessDeny NoAccess={NoAccess} setNoAccess={setNoAccess} />
      )}
      {popupType != "" && (
        <PopupModal
          popupType={popupType}
          setPopupType={setPopupType}
          error={Error}
          Message={message}
        />
      )}

      {siteData && <HomeMeta siteData={siteData} />}
    </>
  );
};
export { Navbar };
